<template>
	<div class="im-service-ended">
		<section class="im-service-ended__main">
				<div class="im-service-ended__tools">
					<el-form :model="form" class="form">
						<el-row>
							<el-col :span="18">
								<el-date-picker class="real-date" v-model="form.date" type="daterange"
									format="yyyy/MM/dd" value-format="timestamp" clearable size="mini" style="width: 100%;"
									start-placeholder="开始时间" end-placeholder="结束时间" range-separator="至"></el-date-picker>
							</el-col>
						</el-row>
						<el-row :gutter="10" style="margin-top: 5px;">
							<el-col :span="18">
								<el-input placeholder="搜索名称" suffix-icon="el-icon-search" clearable v-model="form.name" size="mini">
								</el-input>
							</el-col>
							<el-col :span="6">
								<el-button type="primary" @click="toSearch" size="mini" :loading="btn_loading">{{btn_loading ? '' : '确定'}}</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-row :gutter="20" style="margin-top: 20px;">
						<el-col :span="12">
							<h4>用户名称</h4>
						</el-col>
						<el-col :span="12">
							<span class="text">对话结束时间</span>
						</el-col>
					</el-row>
				</div>
				<div class="im-service-ended__box">
					<virtual-list class="list-infinite scroll-touch"
					  :data-key="'session_id'"
					  :data-sources="lists"
					  :extra-props="{'session_id':session_id}"
					  :estimate-size="91"
					  :data-component="itemComponent"
					  :item-class="'list-item-infinite'"
					  v-on:tobottom="handlerScroll"
					  v-on:toSwitchUserTab="toSwitchUserTab"
					  v-on="$listeners"
					>
					<div slot="footer" class="loading-toobar">
						<el-button @click="toMore()" type="text" :disabled="!isMore" :loading="loading">{{loading ? '加载中...' : isMore ? '加载更多' : '没有更多数据咯'}}</el-button>
					</div>
					</virtual-list>
				</div>    
		</section>
	</div>
</template>

<script>
	import { formatTalkUser } from '@/utils/imService'
	import endItem from './ended-item.vue';
	export default {
		data() {
			return {
				itemComponent:endItem,
				loading: false,
				lists:[],
				form: {
					date: '',
					name: "",
				},
				listQuery: {
					pageNum: 1,
					pageSize: 8,
					startTime: '',
					endTime: '',
					nickname: ''
				},
				totalSize:0,
				isMore:true,
				session_id:'',//默认当前选中会话
				btn_loading:false,
			}
		},
		methods:{
			handlerScroll(){
				if(!this.isMore)return;
				this.toMore();
			},
			toMore(){
				this.listQuery.pageNum++;
				if(this.listQuery.pageNum > this.totalSize) {
					this.isMore = false;
					this.listQuery.pageNum = 1;
				}else {
					this.isMore = true;
				}
				this.getData();
			},
			toSearch(){
				 this.btn_loading = true;
				 this.listQuery.startTime = this.form.date? this.form.date[0] : '';
				 this.listQuery.endTime = this.form.date ? this.form.date[1] : '';
				 this.listQuery.nickname = this.form.name;
				 this.listQuery.pageNum = 1;
				 this.lists = [];
				 this.getData()
			},
			getData(){
				this.loading  =true
				this.$api.getImServiceEndedLists(this.$store.getters.agentId,this.listQuery).then(res => {
					this.loading = false;
					 this.btn_loading = false;
					if(res.errcode != 0) return;
					let results = res.list.map(item => formatTalkUser(item));
					this.lists = results.length > 0 ?  this.lists.concat(results) : results;
					this.totalSize = res.pages;
					this.isMore = res.pages > this.listQuery.pageNum;
					this.session_id = this.lists.length > 0 ?this.lists[0].session_id : '';
					this.$emit('toSwitchUserTab',this.session_id ? this.lists[0] : {});
				})
			},
			toSwitchUserTab(data){
				this.session_id = data.session_id;
			}
			
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style lang="scss" scoped>
	.im-service-ended {
		width: 100%;
		height: 100%;
		display: flex;
		&__main {
			position: relative;
			height: 100%;
		}
		
		&__tools {
			width: 100%;
			padding: 14px 10px;
			
			h4 {
				color: #337eff;
				font-weight: 500;
				font-size: 14px;
			}
			.text {
				float: right;
				font-size: 14px;
				color: #566980;
				font-weight: 500;
			}
		}
		&__box {
			height: calc(100% - 143px);
			overflow: hidden;
			box-sizing: border-box;
			.scroll-touch {
				height: 100%;
				overflow: scroll;
			}
			.loading-toobar {
				display: flex;
				justify-content: center;
			}
		}
	}
</style>